import { type FAQItem } from '@/mocks/faq';

interface FAQSectionProps {
  items: FAQItem[];
}

export default function FAQSection({ items }: FAQSectionProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
      <div className="space-y-3">
        {items.map((item, index) => (
          <details
            key={index}
            className="bg-background-50 border border-background-200/70 rounded-lg group cursor-pointer"
          >
            <summary className="flex items-center justify-between px-5 py-4 text-sm font-medium text-foreground-800 list-none">
              <span>{item.question}</span>
              <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200 ml-3"></i>
            </summary>
            <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
              {item.answer}
            </div>
          </details>
        ))}
      </div>
    </>
  );
}